import * as React from 'react';
import { Image, type ImageProps } from '@/hen-ui/atomics/Image';
import { cn } from '@/hen-ui/utils';

export type GridImageProps = Omit<ImageProps, 'className'>;

/**
 * GridImage - Composite component wrapper for Image component used in ImageGrid
 *
 * Applies the necessary className ('object-contain max-w-full max-h-full') to ensure
 * images display correctly within ImageGrid's grid layout.
 *
 * @example
 * ```tsx
 * <ImageGrid variant="grid">
 *   <GridImage src="/image.jpg" alt="Image" />
 *   <GridImage src="/image2.jpg" alt="Image 2" />
 * </ImageGrid>
 * ```
 */
export const GridImage = React.forwardRef<HTMLImageElement, GridImageProps>(
  ({ ...props }, ref) => {
    return (
      <div
        role='listitem'
        className='flex-shrink-0 max-w-[220px] max-h-[92px] flex p-5'
      >
        <Image ref={ref} {...props} objectFit='contain' />
      </div>
    );
  },
);

GridImage.displayName = 'GridImage';
